export const store = {
    state: {
        dropdownItems: [],
        pageViewId: null,
        psh: null,
        rootColors: {
            whiteText: '#FFFFFF',
            primaryBtnBg: '#62BE76',
            secondaryBtnBg: '#439DFF',
            inactiveBg: '#E4E9EC',
        },
        layoutType: null,
    },
    setPsh(psh) {
        this.state.psh = psh;
    },
    setPageViewId(pageViewId) {
        this.state.pageViewId = pageViewId;
    },
    setLayoutType(layoutType) {
        this.state.layoutType = layoutType;
    },
};
